import { ReactNode } from 'react'
import { Grid2, Typography } from '@mui/material'
import { decodeHtml } from '@/utils/text'

export default function FieldValue({
  field,
  value,
}: {
  field: string
  value?: string | ReactNode
}) {
  return (
    <>
      <Grid2 size={6}>
        <Typography variant="body2" color="text.secondary">
          {field}:
        </Typography>
      </Grid2>
      <Grid2 size={6}>
        <Typography
          variant="body2"
          color={value === undefined ? 'text.secondary' : undefined}
        >
          {value === undefined
            ? 'None'
            : typeof value === 'string'
            ? decodeHtml(value)
            : value}
        </Typography>
      </Grid2>
    </>
  )
}
